import { createApiCall, MethodType, URI } from "../Api";
import { IDefaultSettingPayload } from "models/setting/default";
import { IVerifyPhoneNumberPayload } from "models/setting/verifyPhoneNumber";

export const getInformationSetting = () => {
  return createApiCall(MethodType.GET, URI.SETTING.INFO);
};

export const setDefaultSetting = (payload: IDefaultSettingPayload) => {
  return createApiCall(MethodType.POST, URI.SETTING.DEFAULT, payload);
};

export const verifyOTP = (payload: any) => {
  return createApiCall(MethodType.POST, URI.SETTING.VERIFY_OTP, payload);
};

export const voiceCall = (payload: any) => {
  return createApiCall(MethodType.POST, URI.SETTING.VOICE_CALL, payload);
};

export const verifyMobileNumber = (payload: IVerifyPhoneNumberPayload) => {
  return createApiCall(
    MethodType.POST,
    URI.SETTING.VERIFY_MOBILE_NUMBER,
    payload
  );
};

export const patientRegistration = (payload: any) => {
  return createApiCall(
    MethodType.POST,
    URI.SETTING.PATIENT_REGISTRATION,
    payload
  );
};
